import React from "react";
import "./loadingSkeleton.scss";

const Loading = () => {
  return <div className="loader"></div>;
};

export default Loading;
